import { createSelector } from '@ngrx/store';

import { notificationFeature } from './notification.feature';

export const selectNotifications = notificationFeature.selectNotifications;
export const selectUnseenCount = notificationFeature.selectUnseenCount;
export const selectLoading = notificationFeature.selectLoading;
export const selectError = notificationFeature.selectError;

export const selectHasUnseen = createSelector(
  selectUnseenCount,
  (unseenCount) => unseenCount > 0,
);
